const Home = () => import('../pages/home').then(m => m.default || m)
const Trck = () => import('../pages/trck').then(m => m.default || m)

const Login = () => import('../pages/auth/msisdn').then(m => m.default || m)
//const Login = () => import('../pages/auth/login').then(m => m.default || m)
const PasswordReset = () => import('../pages/auth/password/reset').then(m => m.default || m)
const PasswordRequest = () => import('../pages/auth/password/email').then(m => m.default || m)

const Settings = () => import('../pages/settings/index').then(m => m.default || m)
const SettingsProfile  = () => import('../pages/settings/profile').then(m => m.default || m)
const SettingsPassword = () => import('../pages/settings/password').then(m => m.default || m)
const SettingsSubscriptions = () => import('../pages/settings/subscriptions').then(m => m.default || m)
const SettingsFavourites = () => import('../pages/settings/favourites').then(m => m.default || m)

const AppsIndex = () => import('../pages/apps/index').then(m => m.default || m)
const AppsShow  = () => import('../pages/apps/show').then(m => m.default || m)
const GamesIndex = () => import('../pages/games/index').then(m => m.default || m)
const GamesShow  = () => import('../pages/games/show').then(m => m.default || m)
const GamesPreview  = () => import('../pages/games/preview').then(m => m.default || m)
const WallpapersIndex = () => import('../pages/wallpapers/index').then(m => m.default || m)
const WallpapersShow  = () => import('../pages/wallpapers/show').then(m => m.default || m)
const VideosIndex = () => import('../pages/videos/index').then(m => m.default || m)
const VideosShow  = () => import('../pages/videos/show').then(m => m.default || m)
const VideosPreview  = () => import('../pages/videos/preview').then(m => m.default || m)
const MusicsIndex = () => import('../pages/musics/index').then(m => m.default || m)
const MusicsShow  = () => import('../pages/musics/show').then(m => m.default || m)
const SportsIndex = () => import('../pages/sports/index').then(m => m.default || m)
const SportsShow  = () => import('../pages/sports/show').then(m => m.default || m)
const WidgetsIndex = () => import('../pages/widgets/index').then(m => m.default || m)
const WidgetsShow  = () => import('../pages/widgets/show').then(m => m.default || m)
const EbooksIndex = () => import('../pages/ebooks/index').then(m => m.default || m)
const EbooksShow  = () => import('../pages/ebooks/show').then(m => m.default || m)

const CookiesPolicy    = () => import('../pages/CookiesPolicy').then(m => m.default || m)
const Terms    = () => import('../pages/Terms').then(m => m.default || m)
const TEC = () => import('../pages/tec/index').then(m => m.default || m)
const CookiePolicy = () => import('../pages/policy/index').then(m => m.default || m)

const Subscribe = () => import('../pages/subscribe/index').then(m => m.default || m)
const Welcome = () => import('../pages/subscribe/welcome').then(m => m.default || m)
const Unsubscribed = () => import('../pages/subscribe/unsubscribed').then(m => m.default || m)

const Contacto = () => import('../pages/contact/index').then(m => m.default || m)

const Lang = () => import('../pages/lang').then(m => m.default || m)


export default [
    {path: '/', name: 'home', component: Home},
    {path: '/trck', name: 'trck', component: Trck},

    {path: '/login', name: 'login', component: Login},
    {path: '/password/reset', name: 'password.request', component: PasswordRequest},
    {path: '/password/reset/:token', name: 'password.reset', component: PasswordReset},

    {
        path: '/settings', component: Settings, children: [
            {path: '', redirect: {name: 'settings.profile'}},
            {path: 'password', name: 'settings.password', component: SettingsPassword},
        ]
    },

    {path: '/profile', name: 'profile', component: SettingsProfile},
    {path: '/subscriptions', name: 'subscriptions', component: SettingsSubscriptions},
    {path: '/favourites', name: 'favourites', component: SettingsFavourites},

    {path: '/apps/', name: 'apps.index', component: AppsIndex},
    {path: '/apps/:slug', name: 'apps.show', component: AppsShow},

    {path: '/sports/', name: 'sports.index', component: SportsIndex},
    {path: '/sports/:slug', name: 'sports.show', component: SportsShow},
    {path: '/sports/search/:query', name: 'sports.search', component: SportsIndex},

    {path: '/widgets/', name: 'widgets.index', component: WidgetsIndex},
    {path: '/widgets/:slug', name: 'widgets.show', component: WidgetsShow},

    {path: '/games/', name: 'games.index', component: GamesIndex},
    {path: '/games/:slug', name: 'games.show', component: GamesShow},
    {path: '/games/preview/:slug', name: 'games.preview', component: GamesPreview},

    {path: '/wallpapers/', name: 'wallpapers.index', component: WallpapersIndex},
    {path: '/wallpapers/:slug', name: 'wallpapers.show', component: WallpapersShow},

    {path: '/videos/', name: 'videos.index', component: VideosIndex},
    {path: '/videos/:slug', name: 'videos.show', component: VideosShow},
    {path: '/videos/preview/:slug', name: 'videos.preview', component: VideosPreview},

    {path: '/musics/', name: 'musics.index', component: MusicsIndex},
    {path: '/musics/:slug', name: 'musics.show', component: MusicsShow},

    {path: '/ebooks/', name: 'ebooks.index', component: EbooksIndex},
    {path: '/ebooks/:slug', name: 'ebooks.show', component: EbooksShow},


    {path: '/cookies-policy', name: 'cookies-policy', component: CookiesPolicy},
    {path: '/pages/policy', name: 'policy', component: CookiePolicy},
    {path: '/terms', name: 'terms', component: Terms},
    {path: '/pages/tec', name: 'tec', component: TEC},

    {path: '/cancel-subscription', name: 'cancel-subscription', component: Subscribe},
    {path: '/welcome', name: 'welcome', component: Welcome},
    {path: '/unsubscribed', name: 'unsubscribed', component: Unsubscribed},

    {path: '/pages/contact', name: 'contact', component: Contacto},

    {path: '/lang/:slug/:slug', name: 'lang', component: Lang},

    {path: '*', name: '404', component: require('../pages/errors/404.vue')},
    {path: '/waiting', name: 'waiting', component: require('../pages/errors/waiting.vue')}
]



// WEBPACK FOOTER //
// ./resources/assets/js/router/routes.js